import { toRem, toRems } from 'helpers/theme'

/* eslint-disable quote-props */
const style = ({ theme, image }) => ({
    margin: toRem(20),
    [theme.breakpoints.up('md')]: {
        paddingBottom: toRem(150)
    },

    '& .ManageContainer': {
        maxWidth: 1440,
        margin: 'auto',
        padding: toRem(20),

        [theme.breakpoints.up('lg')]: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: 0,
            marginTop: toRem(-100),
            marginBottom: toRem(-100),
        },

        '& .Content': {
            [theme.breakpoints.up('lg')]: {
                width: '50%'
            },

            [theme.breakpoints.up('xl')]: {
                padding: toRems([70, 80])
            },

            '& .Title': {
                maxWidth: toRem(270),
                marginBottom: toRem(20),
                color: theme.colors.goldDark,
                fontSize: toRem(20),

                [theme.breakpoints.up('md')]: {
                    marginBottom: toRem(30),
                    fontSize: toRem(24),
                    fontWeight: '500'
                }
            },

            '& .Subtitle': {
                fontSize: toRem(14),
                marginBottom: toRem(40),
                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(20)
                }
            },

            '& .Text': {
                marginBottom: toRem(35),

                [theme.breakpoints.up('md')]: {
                    fontSize: toRem(20),
                    marginBottom: toRem(72)
                },

                p: {
                    fontSize: toRem(14),
                    lineHeight: '24px',
                    marginBottom: toRem(20),

                    [theme.breakpoints.up('md')]: {
                        fontSize: toRem(20)
                    }
                }
            },
            '& .Statistics': {
                listStyle: 'none',
                margin: 0,
                display: 'flex'
            }
        },
        '& .ManageGrid': {
            padding: toRems([40, 0, 10]),
            [theme.breakpoints.up('lg')]: {
                width: '45%',
                paddingTop: 0
            },

            [theme.breakpoints.up('xl')]: {
                padding: toRems([30, 80, 70, 0])
            },

            ul: {
                listStyle: 'none',
                display: 'flex',
                flexWrap: 'wrap',
                marginLeft: toRem(-25),
                marginRight: toRem(-25),
                [theme.breakpoints.up('md')]: {
                    marginLeft: toRem(-10),
                    marginRight: toRem(-10)
                },
                li: {
                    width: '33.33%',
                    padding: toRem(5),
                    [theme.breakpoints.up('md')]: {
                        padding: toRem(10)
                    }
                }
            }
        }
    }
})

export default style
